import React from 'react';
import { Box, Select } from "@amzn/awsui-components-react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import {BETA_STAGE, GAMMA_STAGE, PROD_STAGE} from "../../../constants";

interface StageSelectorProps {
  stage: string;
  setStage: (stage: string) => void;
}

export const StageSelector: React.FC<StageSelectorProps> = ({
  stage,
  setStage
}) => {
  return (
    <SpaceBetween size="xs">
      <Box>Environment</Box>
      <Select
        selectedOption={{ label: stage, value: stage }}
        onChange={({ detail }) => {
          const newStage = detail.selectedOption.value || stage;
          setStage(newStage);
        }}
        options={[
          { label: PROD_STAGE, value: PROD_STAGE },
          { label: GAMMA_STAGE, value: GAMMA_STAGE },
          { label: BETA_STAGE, value: BETA_STAGE },
        ]}
        selectedAriaLabel="Selected"
        placeholder="Select a stage"
        ariaRequired={true}
      />
    </SpaceBetween>
  );
};
